// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__wX_cD","legacyBtn":"MutateMid_legacyBtn__3_lJG"};